/* eslint-disable max-len */
import cn from 'classnames';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import AboutWorkCard from '../AboutWorkCard';
import ArrowRightIconV2 from '../SVGIcons/ArrowRightIconV2';
import classes from './about-work.module.scss';
import { AboutWorkProps, CardNamesType } from './AboutWork.type';

function AboutWork({
  button,
  data,
}: AboutWorkProps) {
  const cardNamesArray: CardNamesType[] = ['First', 'Second', 'Third', 'Fourth'];

  function extractWorkCards(cardNumbers: CardNamesType[]) {
    const getCardDetails = (number: 'First' | 'Second' | 'Third' | 'Fourth') => ({
      title: data[`aboutWork${number}CardTitle`],
      subtitle: data[`aboutWork${number}CardSubtitle`],
      detail: data[`aboutWork${number}CardDetail`],
    });

    return cardNumbers.map(getCardDetails);
  }

  const dataCards = extractWorkCards(cardNamesArray);

  return data.aboutWorkShow ? (
    <div
      className={cn(classes.container, {
        [classes['container-green']]: data.aboutWorkIsGreenBackground,
      })}
    >
      {data.aboutWorkTitle && <p className={classes.heading}>{data.aboutWorkTitle}</p>}
      <div className={classes.advantagesWrapper}>
        <div className={classes.advantagesContainer}>
          {dataCards.map((card) => (
            <AboutWorkCard
              title={card.title}
              subtitle={card.subtitle}
              description={card.detail}
            />
          ))}
        </div>

        <Link to={button.link} className={classes.vacancies}>
          {button.text}
          <div>
            <ArrowRightIconV2 fill="white" />
          </div>
        </Link>
      </div>
    </div>
  ) : null;
}

export default memo(AboutWork);
